/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _recompose = require("../utils/recompose");
var _TimeProvider = _interopRequireDefault(require("../containers/TimeProvider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var withTimeProvider = function withTimeProvider(timeProviderProps) {
  return function (WrappedComponent) {
    var WithTimeProvider = function WithTimeProvider(props) {
      return /*#__PURE__*/_react["default"].createElement(_TimeProvider["default"], _extends({
        updateInterval: props.updateInterval
      }, timeProviderProps), function (timeProps) {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, timeProps, props));
      });
    };
    WithTimeProvider.defaultProps = WrappedComponent.defaultProps;
    WithTimeProvider.propTypes = WrappedComponent.propTypes;
    WithTimeProvider.displayName = (0, _recompose.wrapDisplayName)(WrappedComponent, 'withTimeProvider');
    return WithTimeProvider;
  };
};
var _default = withTimeProvider;
exports["default"] = _default;